import React from 'react';

export interface ViewContainerAction {
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary' | 'danger';
    icon?: React.ReactNode;
    disabled?: boolean;
}

interface DetailViewProps {
    onBack: () => void;
    children?: React.ReactNode;
    /** Optional hide back button edit */
    onEdit?: boolean;
    title: string;
    viewDescription?: string;
    /** Optional custom action buttons to display in the header */
    actions?: ViewContainerAction[];
    /** Optional footer action buttons (for Save, Cancel, etc.) */
    footerActions?: ViewContainerAction[];
}

export const ViewContainer: React.FC<DetailViewProps> = (props) => {

    const getFooterButtonClass = (variant: ViewContainerAction['variant'] = 'secondary', disabled?: boolean) => {
        if (variant === 'primary') {
            return `px-8 py-3.5 text-sm font-bold text-white bg-primaryGreen border border-transparent rounded-xl shadow-lg shadow-primaryGreen/25 hover:shadow-xl hover:shadow-primaryGreen/35 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 disabled:hover:scale-100 flex items-center gap-2.5 cursor-pointer uppercase tracking-wider ${ disabled ? 'opacity-50 cursor-not-allowed' : '' }`;
        } else if (variant === 'danger') {
            return `px-8 py-3.5 text-sm font-bold text-white bg-red-500 border border-transparent rounded-xl shadow-lg shadow-red-500/25 hover:shadow-xl hover:shadow-red-500/35 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 disabled:hover:scale-100 flex items-center gap-2.5 cursor-pointer uppercase tracking-wider ${ disabled ? 'opacity-50 cursor-not-allowed' : '' }`;
        } else {
            return `px-7 py-3.5 text-sm font-bold text-gray-600 hover:text-darkGreen hover:bg-gray-50 border border-gray-200 rounded-xl hover:border-gray-300 transition-all duration-200 cursor-pointer uppercase tracking-wider ${ disabled ? 'opacity-50 cursor-not-allowed' : '' }`;
        }
    };

    return (
        <div className="animate-in slide-in-from-right duration-300 bg-slate-50 w-full detail-view overflow-hidden flex flex-col h-[calc(100vh-4rem)] border-t border-slate-200 relative">
            <div className="absolute top-0 left-0 right-0 h-px bg-slate-200"></div>

            <div className="flex-1 overflow-y-auto">
                {props.children && props.children}
            </div>
            {props.footerActions && props.footerActions.length > 0 && (
                <div className="sticky bottom-0 flex items-center justify-between px-8 py-5 border-t border-gray-200 bg-white flex-shrink-0">
                    <div className="flex items-center gap-4 w-full justify-end">
                        {props.footerActions.map((action, index) => (
                            <button
                                key={index}
                                onClick={action.onClick}
                                disabled={action.disabled}
                                className={getFooterButtonClass(action.variant, action.disabled)}
                            >
                                {action.icon}
                                {action.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};


